module.exports = __webpack_public_path__ + "img/351.61f39626.jpg";